import { render, staticRenderFns } from "./AEiLoading.vue?vue&type=template&id=2b56d04c&"
import script from "./AEiLoading.vue?vue&type=script&lang=ts&"
export * from "./AEiLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports